
import { defineMessages } from 'react-intl';

export default defineMessages({
  contentRequired: 'Content is required',
  save: 'Save',

  introTitle: 'Introduction',
  editIntro: 'Edit introduction',
  showOnSeparatePage: 'Show intro on a separate page',
  separatePageTooltip: 'Showing intro on a separate page is recommended as it allows the user to opt out from the survey. However it might yield a lower response rate.',
  introSaveSuccess: 'Introduction saved!',
  introSaveFail: 'Failed to save introduction. Please try again later.',

  closingTitle: 'Closing text',
  editClosing: 'Edit closing text',
  closingSaveSuccess: 'Closing text saved!',
  closingSaveFail: 'Failed to save closing text. Please try again later.',
});
